import { AxiosInstance } from 'axios';

import { SObject, Aligned, Action } from '@/types';

type Primitive = string | boolean | number;

export interface DeployAction {
  action: Action;
  sobject: SObject;
  values: Record<string, Primitive>;
}

export interface DeployResponse {
  history: DeployAction[];
  deployedRootObjectsCount: number;
}

class DeployService {
  private readonly client: AxiosInstance;

  constructor(client: AxiosInstance) {
    this.client = client;
  }

  deploy(aligned: Aligned[]): Promise<DeployResponse> {
    return this.client
      .post<DeployResponse>('/apis/salesforce/v1/deploy', {
        aligned,
      })
      .then(({ data }) => data);
  }

  dryRun(aligned: Aligned[]): Promise<DeployResponse> {
    return this.client
      .post<DeployResponse>('/apis/salesforce/v1/dry-run', {
        aligned,
      })
      .then(({ data }) => data);
  }
}

export default DeployService;
